<template>
    <rkm-modal
        :loading="loading"
        :title="'Detalhes (' + getSafely(() => requisicao.numero, '')  + ')'"
        extraLarge
        ref="Modal"
    >
        <template v-if="requisicao">
            <template v-if="hasRespostas">
                <rkm-table
                    v-for="(resposta, i) in requisicao.respostas"
                    :class="{ 'mt-3': i > 0 }"
                    :fields="getFields(resposta.numeroResposta === 1)"
                    :items="resposta.itens"
                    :key="resposta.numeroResposta"
                    class="table-resposta"
                    hide-filters
                    hide-pagination
                >
                    <template #thead-top>
                        <rkm-tr>
                            <rkm-th :colspan="getFields(resposta.numeroResposta === 1).length">
                                <span><strong>{{ resposta.numeroResposta }}ª resposta</strong></span>
                                <span v-if="resposta.dataHoraEnvio"><br>Data/hora envio: {{ resposta.dataHoraEnvio }} ({{ resposta.usuarioEnvio }})</span>
                                <span v-if="resposta.dataHoraRecebimento"><br>Data/hora recebimento: {{ resposta.dataHoraRecebimento }}</span>
                            </rkm-th>
                        </rkm-tr>
                    </template>

                    <template v-slot:cell(enviado)="{ item }">
                        <template v-if="item.possuiEntradaComLote">
                            <template v-if="item.entradaItens.length > 0">
                                <div
                                    v-for="(lote, i) in item.entradaItens"
                                    :key="`${i}${lote.lote}`"
                                >
                                    {{ lote.enviado }}
                                </div>
                            </template>

                            <template v-else>
                                0
                            </template>
                        </template>

                        <template v-else>
                            {{ item.enviado }}
                        </template>
                    </template>

                    <template v-slot:cell(recebido)="{ item }">
                        <template v-if="item.possuiEntradaComLote">
                            <template v-if="item.entradaItens.length > 0">
                                <div
                                    v-for="(lote, i) in item.entradaItens"
                                    :key="`${i}${lote.lote}`"
                                >
                                    {{ lote.recebido }}
                                </div>
                            </template>

                            <template v-else>
                                0
                            </template>
                        </template>

                        <template v-else>
                            {{ item.recebido }}
                        </template>
                    </template>

                    <template v-slot:cell(lote)="{ item }">
                        <template v-if="item.possuiEntradaComLote">
                            <template v-if="item.entradaItens.length > 0">
                                <div
                                    v-for="(lote, i) in item.entradaItens"
                                    :key="`${i}${lote.lote}`"
                                >
                                    {{ lote.lote || '-' }}
                                </div>
                            </template>

                            <template v-else>
                                -
                            </template>
                        </template>

                        <template v-else>
                            -
                        </template>
                    </template>

                    <template v-slot:cell(validadeLote)="{ item }">
                        <template v-if="item.possuiEntradaComLote">
                            <template v-if="item.entradaItens.length > 0">
                                <div
                                    v-for="(lote, i) in item.entradaItens"
                                    :key="`${i}${lote.lote}`"
                                >
                                    {{ lote.validadeLote || '-' }}
                                </div>
                            </template>

                            <template v-else>
                                -
                            </template>
                        </template>

                        <template v-else>
                            -
                        </template>
                    </template>

                    <template v-slot:cell(motivoDiferenca)="{ value }">
                        {{ value || '-' }}
                    </template>

                    <template
                        v-if="resposta.observacoes"
                        #afterTable
                    >
                        <div class="footer">
                            <span>
                                <strong>Observações:</strong> {{ resposta.observacoes }}
                            </span>
                        </div>
                    </template>
                </rkm-table>
            </template>

            <rkm-table
                v-else
                :fields="getFields(true)"
                :items="requisicao.itens"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(enviado)>-</template>
                <template v-slot:cell(recebido)>-</template>
                <template v-slot:cell(lote)>-</template>
                <template v-slot:cell(validadeLote)>-</template>
                <template v-slot:cell(motivoDiferenca)>-</template>
            </rkm-table>
        </template>

        <template #footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="printDetails(requisicao)"
                color="primary"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Others.
import { mapActions, mapGetters } from 'vuex'
import { repository, error, object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        hasRespostas() {

            return this.requisicao.respostas.length  > 0
        }
    },
    created() {

        this.repositories = {
            relatorioRequisicao: this.getConectaSusRepository('almoxarifado.relatorioRequisicao'),
        }
    },
    data: () => ({
        filterParams: null,
        requisicaoId: null,
        requisicao: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(requisicaoId, filterParams) {

            this.filterParams = filterParams
            this.requisicaoId = requisicaoId
            this.requisicao = null

            this.load()
            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.relatorioRequisicao.index({
                ...this.filterParams,
                requisicao_id: this.requisicaoId,
                with_details: true,
            })
                .then(({ data }) => this.requisicao = data.requisicoes[0])
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getFields(isPrimeiroRecebimento) {

            return [
                {
                    key: 'material',
                    label: 'Material',
                },
                {
                    key: 'requisitado',
                    label: isPrimeiroRecebimento ? 'Requisitado' : 'Restante requisitado',
                    class: 'col-min text-center'
                },
                {
                    key: 'lote',
                    label: 'Lote',
                    class: 'col-min text-center'
                },
                {
                    key: 'validadeLote',
                    label: 'Validade',
                    class: 'col-min text-center'
                },
                {
                    key: 'enviado',
                    label: 'Enviado',
                    class: 'col-min text-center'
                },
                {
                    key: 'recebido',
                    label: 'Recebido',
                    class: 'col-min text-center'
                },
                {
                    key: 'motivoDiferenca',
                    label: 'Motivo da diferença entre solicitado e enviado',
                },
            ]
        },
    },
    mixins: [repository, error, object],
    props: {
        printDetails: { type: Function, required: true },
    },
}
</script>

<style scoped>
.table-resposta >>> .footer {
    background: #f1f1f1;
    border: 1px solid #dee2e6;

    padding: 0.5rem;
}
</style>